import {Navigate, Outlet, useLocation} from 'react-router-dom';
import {useAuth} from '../context/AuthContext';
import AuthenticationBackoffice from './AuthenticationBackoffice';
import ContainerBackoffice from './ContainerBackoffice';

export const ProtectedBackoffice = () => {
    const {logged, user} = useAuth();
    const location = useLocation();

    if (!logged) {
        // Salva a URL atual antes de mostrar o login
        const currentPath = location.pathname + location.search;
        sessionStorage.setItem('redirectAfterLogin', currentPath);
        return <AuthenticationBackoffice />;
    }

    // if(user.team)
    return (
        <ContainerBackoffice>
            <Outlet />
        </ContainerBackoffice>
    );
};
